import { render, staticRenderFns } from "./clientdashboard-navigation.vue?vue&type=template&id=b5f3569e&scoped=true&"
import script from "./clientdashboard-navigation.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-navigation.vue?vue&type=script&lang=js&"
import style0 from "./clientdashboard-navigation.vue?vue&type=style&index=0&id=b5f3569e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f3569e",
  null
  
)

export default component.exports